// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clientdashboard-container {
  max-width: 600px;
  margin: auto;
  padding: 16px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.2);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  color: white;
}

.clientdashboard-header {
  color: #2e275a;
}

.clientdashboard-hourly-rate {
  margin-bottom: 24px;
}

.clientdashboard-hourly-rate input {
  padding: 8px;
  width: 100px;
}

.clientdashboard-hourly-rate span {
  font-weight: bold;
}

.clientdashboard-info-box {
  margin-bottom: 24px;
  font-size: 15px;
  color: white;
  background: rgba(0, 0, 0, 0.2);
  padding: 12px;
  border-radius: 8px;
}

.clientdashboard-adjustment-box {
  margin: 1rem 0;
  background: #f9f9f9;
  padding: 12px;
  border-radius: 8px;
}

.clientdashboard-adjustment-box h3 {
  margin: 0;
  color: #2e275a;
}

.clientdashboard-adjustment-box input {
  padding: 6px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.clientdashboard-adjustment-box button {
  background: #2e275a;
  color: white;
  border: 0;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  font-weight: bold;
}

.clientdashboard-adjustment-box .info {
  font-size: 12px;
  color: #888;
  margin-top: 4px;
}

.clientdashboard-custom-payment {
  margin: 1rem 0;
}

.clientdashboard-custom-payment input {
  width: 100px;
  margin-left: 8px;
  margin-right: 8px;
}

.clientdashboard-custom-payment button {
  background: #2e275a;
  color: white;
  border: 0;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  font-weight: bold;
}

.clientdashboard-payment-history-header {
  margin-bottom: 12px;
  color: #2e275a;
}

.clientdashboard-download-button {
  background: #deb841;
  color: #222;
  border: 0;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  font-weight: bold;
}

.clientdashboard-payment-card {
  background: rgba(0, 0, 0, 0.2);
  padding: 12px;
  border-radius: 6px;
  font-size: 14px;
  color: white;
}

.clientdashboard-payment-card strong {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/ClientToTrainerPayments.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".clientdashboard-container {\n  max-width: 600px;\n  margin: auto;\n  padding: 16px;\n  border-radius: 12px;\n  background: rgba(0, 0, 0, 0.2);\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);\n  color: white;\n}\n\n.clientdashboard-header {\n  color: #2e275a;\n}\n\n.clientdashboard-hourly-rate {\n  margin-bottom: 24px;\n}\n\n.clientdashboard-hourly-rate input {\n  padding: 8px;\n  width: 100px;\n}\n\n.clientdashboard-hourly-rate span {\n  font-weight: bold;\n}\n\n.clientdashboard-info-box {\n  margin-bottom: 24px;\n  font-size: 15px;\n  color: white;\n  background: rgba(0, 0, 0, 0.2);\n  padding: 12px;\n  border-radius: 8px;\n}\n\n.clientdashboard-adjustment-box {\n  margin: 1rem 0;\n  background: #f9f9f9;\n  padding: 12px;\n  border-radius: 8px;\n}\n\n.clientdashboard-adjustment-box h3 {\n  margin: 0;\n  color: #2e275a;\n}\n\n.clientdashboard-adjustment-box input {\n  padding: 6px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n}\n\n.clientdashboard-adjustment-box button {\n  background: #2e275a;\n  color: white;\n  border: 0;\n  border-radius: 6px;\n  padding: 0.5rem 1rem;\n  font-weight: bold;\n}\n\n.clientdashboard-adjustment-box .info {\n  font-size: 12px;\n  color: #888;\n  margin-top: 4px;\n}\n\n.clientdashboard-custom-payment {\n  margin: 1rem 0;\n}\n\n.clientdashboard-custom-payment input {\n  width: 100px;\n  margin-left: 8px;\n  margin-right: 8px;\n}\n\n.clientdashboard-custom-payment button {\n  background: #2e275a;\n  color: white;\n  border: 0;\n  border-radius: 6px;\n  padding: 0.5rem 1rem;\n  font-weight: bold;\n}\n\n.clientdashboard-payment-history-header {\n  margin-bottom: 12px;\n  color: #2e275a;\n}\n\n.clientdashboard-download-button {\n  background: #deb841;\n  color: #222;\n  border: 0;\n  border-radius: 6px;\n  padding: 0.5rem 1rem;\n  font-weight: bold;\n}\n\n.clientdashboard-payment-card {\n  background: rgba(0, 0, 0, 0.2);\n  padding: 12px;\n  border-radius: 6px;\n  font-size: 14px;\n  color: white;\n}\n\n.clientdashboard-payment-card strong {\n  display: block;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
